var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfiletick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.37996 2 7.24996 4.13 7.24996 6.75C7.24996 9.32 9.25996 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49H12.17C13.3993 11.449 14.5645 10.9315 15.4192 10.0469C16.274 9.16234 16.7512 7.98004 16.75 6.75C16.75 4.13 14.62 2 12 2ZM17.08 14.16C14.29 12.3 9.73996 12.3 6.92996 14.16C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91996 20.59C8.31996 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.14 18.34 14.99 17.08 14.16ZM14.33 16.56L11.81 19.08C11.7521 19.1375 11.6834 19.183 11.6079 19.2138C11.5324 19.2447 11.4515 19.2604 11.37 19.26C11.21 19.26 11.05 19.19 10.93 19.08L9.66996 17.82C9.55465 17.7026 9.49005 17.5446 9.49005 17.38C9.49005 17.2154 9.55465 17.0574 9.66996 16.94C9.90996 16.7 10.31 16.7 10.55 16.94L11.37 17.76L13.45 15.68C13.69 15.44 14.09 15.44 14.33 15.68C14.58 15.92 14.58 16.32 14.33 16.56V16.56Z",
    fill: "#49AE9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiletick);
export default __webpack_public_path__ + "static/media/profiletick.d0eaddec00536133a28f34c2165a44a7.svg";
export { ForwardRef as ReactComponent };